import { render, staticRenderFns } from "./expenseDetail.vue?vue&type=template&id=379f5578&scoped=true"
import script from "./expenseDetail.vue?vue&type=script&lang=js"
export * from "./expenseDetail.vue?vue&type=script&lang=js"
import style0 from "./expenseDetail.vue?vue&type=style&index=0&id=379f5578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379f5578",
  null
  
)

export default component.exports